import { AfterViewInit, ChangeDetectionStrategy, Component, inject, OnInit, signal, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { HttpStatusCode } from 'axios';
import { DashboardInceptedApeService } from '../../dashboard-services/dashboard-incepted-ape/dashboard-incepted-ape.service';
import { SessionStorageService } from '../../../../core/services/session-storage/session-storage.service';
import { SnackbarService } from '../../../../shared/services/snackbar/snackbar.service';
import { InceptedApeSummary } from '../../dashboard-interfaces/incepted-ape-summary.interface';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { InceptedApeByAdvisors } from '../../dashboard-interfaces/incepted-ape-by-advisors.interface';
import { InceptedApeByBranches } from '../../dashboard-interfaces/incepted-ape-by-branches.interface';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { ViewInceptedApeBranchAdvisorsDialog } from '../../dashboard-dialogs/view-incepted-ape-branch-advisors/view-incepted-ape-branch-advisors.dialog';
import { DashboardManagerTeamService } from '../../dashboard-services/dashboard-manager-team/dashboard-manager-team.service';
import { ViewInceptedApeManagerAdvisorsDialog } from '../../dashboard-dialogs/view-incepted-ape-manager-advisors/view-incepted-ape-manager-advisors.dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'dashboard-incepted-ape',
  imports: [
    CommonModule,
    MatCardModule,
    MatExpansionModule,
    MatDividerModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    CurrencyPipe,
    ReactiveFormsModule,
    MatIconModule
  ],
  templateUrl: './incepted-ape.component.html',
  styleUrl: './incepted-ape.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InceptedApeComponent implements OnInit, AfterViewInit {

  private router = inject(Router);
  private sessionStorageService = inject(SessionStorageService);
  private snackBarService = inject(SnackbarService);
  private dashboardInceptedApeService = inject(DashboardInceptedApeService);
  private dashboardManagerTeamService = inject(DashboardManagerTeamService);
  private readonly matDialog = inject(MatDialog);

  protected currentUserRole: string = '';

  protected totalMonthInceptedApe: number = 0;
  protected totalYearInceptedApe: number = 0;
  protected inceptedApeSummary: InceptedApeSummary = {
    monthSinglife: 0,
    monthNonsinglife: 0,
    monthSinglifeCase: 0,
    monthNonsinglifeCase: 0,
    yearSinglife: 0,
    yearNonsinglife: 0,
    yearSinglifeCase: 0,
    yearNonsinglifeCase: 0,
    yearTarget: 0
  };

  private inceptedApeByAdvisorData: InceptedApeByAdvisors[] = [];
  protected inceptedApeByAdvisorTableDisplayDataRow: string[] = [];
  protected inceptedApeByAdvisorTableDisplayFirstColumn: string[] = [];
  protected inceptedApeByAdvisorTableDisplaySecondColumn: string[] = ['monthSinglife', 'monthSinglifeCase', 'monthNonsinglife', 'monthNonsinglifeCase', 'yearSinglife', 'yearSinglifeCase', 'yearNonsinglife', 'yearNonsinglifeCase'];
  protected inceptedApeByAdvisorTableDataSource = new MatTableDataSource<InceptedApeByAdvisors>();

  private inceptedApeByBranchData: InceptedApeByBranches[] = [];
  protected inceptedApeByBranchTableDisplayColumn: string[] = ["branchName", "monthSinglife", "monthSinglifeCase", "monthNonsinglife", "monthNonsinglifeCase", "yearSinglife", "yearSinglifeCase", "yearNonsinglife", "yearNonsinglifeCase", "yearTotal"];
  protected inceptedApeByBranchTableDataSource = new MatTableDataSource<InceptedApeByBranches>();

  private inceptedApeByManagerData: InceptedApeByAdvisors[] = [];
  protected inceptedApeByManagerTableDisplayDataRow: string[] = ["repCode", "personName", "monthSinglife", "monthSinglifeCase", "monthNonsinglife", "monthNonsinglifeCase", "yearSinglife", "yearSinglifeCase", "yearNonsinglife", "yearNonsinglifeCase", "yearTotal"];
  protected inceptedApeByManagerTableDisplayFirstColumn: string[] = ['repCode', 'personName', 'header-row2-month-singlife-group', 'header-row2-month-nonsinglife-group', 'header-row2-year-singlife-group', 'header-row2-year-nonsinglife-group', 'yearTotal'];
  protected inceptedApeByManagerTableDisplaySecondColumn: string[] = ['monthSinglife', 'monthSinglifeCase', 'monthNonsinglife', 'monthNonsinglifeCase', 'yearSinglife', 'yearSinglifeCase', 'yearNonsinglife', 'yearNonsinglifeCase'];
  protected inceptedApeByManagerTableDataSource = new MatTableDataSource<InceptedApeByAdvisors>();

  inceptedApeByAdvisorTableFilterFc = new FormControl("");
  inceptedApeByBranchTableFilterFc = new FormControl("");
  inceptedApeByManagerTableFilterFc = new FormControl("");

  isInceptedApeByAdvisorTableHidden = signal(false);
  isInceptedApeByBranchTableHidden = signal(false);
  isInceptedApeByManagerTableHidden = signal(false);

  @ViewChild('inceptedApeByAdvisorTablePaginator')
  inceptedApeByAdvisorTablePaginator!: MatPaginator;
  @ViewChild('inceptedApeByAdvisorTableSort')
  inceptedApeByAdvisorTableSort = new MatSort();
  @ViewChild('inceptedApeByBranchTablePaginator')
  inceptedApeByBranchTablePaginator!: MatPaginator;
  @ViewChild('inceptedApeByBranchTableSort')
  inceptedApeByBranchTableSort = new MatSort();
  @ViewChild('inceptedApeByManagerTablePaginator')
  inceptedApeByManagerTablePaginator!: MatPaginator;
  @ViewChild('inceptedApeByManagerTableSort')
  inceptedApeByManagerTableSort = new MatSort();

  constructor() { }

  async ngOnInit(): Promise<void> {
    this.currentUserRole = this.sessionStorageService.getCurrentUserRole();

    if (['Corporate', 'BDM'].includes(this.currentUserRole)) {
      this.inceptedApeByAdvisorTableDisplayDataRow = ["repCode", "personName", "branch", "monthSinglife", "monthSinglifeCase", "monthNonsinglife", "monthNonsinglifeCase", "yearSinglife", "yearSinglifeCase", "yearNonsinglife", "yearNonsinglifeCase", "yearTotal"];
      this.inceptedApeByAdvisorTableDisplayFirstColumn = ['repCode', 'personName', 'branch', 'header-row2-month-singlife-group', 'header-row2-month-nonsinglife-group', 'header-row2-year-singlife-group', 'header-row2-year-nonsinglife-group', 'yearTotal'];
    }
    else {
      this.inceptedApeByAdvisorTableDisplayDataRow = ["repCode", "personName", "monthSinglife", "monthSinglifeCase", "monthNonsinglife", "monthNonsinglifeCase", "yearSinglife", "yearSinglifeCase", "yearNonsinglife", "yearNonsinglifeCase", "yearTotal"];
      this.inceptedApeByAdvisorTableDisplayFirstColumn = ['repCode', 'personName', 'header-row2-month-singlife-group', 'header-row2-month-nonsinglife-group', 'header-row2-year-singlife-group', 'header-row2-year-nonsinglife-group', 'yearTotal'];
    }

    await this.getDashboardInceptedApe();

    this.totalMonthInceptedApe = this.inceptedApeSummary.monthSinglife + this.inceptedApeSummary.monthNonsinglife;
    this.totalYearInceptedApe = this.inceptedApeSummary.yearSinglife + this.inceptedApeSummary.yearNonsinglife;

    if (this.inceptedApeByAdvisorData.length > 0) {
      this.inceptedApeByAdvisorTableDataSource.data = this.inceptedApeByAdvisorData;
    } else {
      this.isInceptedApeByAdvisorTableHidden.set(true);
    }

    if (this.inceptedApeByBranchData.length > 0) {
      this.inceptedApeByBranchTableDataSource.data = this.inceptedApeByBranchData;
    } else {
      this.isInceptedApeByBranchTableHidden.set(true);
    }

    if (['Director'].includes(this.currentUserRole)) {
      await this.getDashboardDirectorwiseManagers();
      this.inceptedApeByManagerTableDataSource.data = this.inceptedApeByManagerData;
    } else {
      this.isInceptedApeByManagerTableHidden.set(true);
    }
  }

  ngAfterViewInit(): void {
    this.inceptedApeByAdvisorTableDataSource.paginator = this.inceptedApeByAdvisorTablePaginator;
    this.inceptedApeByAdvisorTableDataSource.sort = this.inceptedApeByAdvisorTableSort;

    this.inceptedApeByBranchTableDataSource.paginator = this.inceptedApeByBranchTablePaginator;
    this.inceptedApeByBranchTableDataSource.sort = this.inceptedApeByBranchTableSort;

    this.inceptedApeByManagerTableDataSource.paginator = this.inceptedApeByManagerTablePaginator;
    this.inceptedApeByManagerTableDataSource.sort = this.inceptedApeByManagerTableSort;
  }

  async getDashboardInceptedApe() {
    const responseData = await this.dashboardInceptedApeService
      .getDashboardInceptedApe()
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        console.error(error);
        return error;
      });

    if (responseData.status === HttpStatusCode.Ok) {
      // Manager, Director : apedata, apesummary
      // Agent : apesummary
      // Corporate : branchdata, corporateapedata
      // BDM : bdmapedata, bdmbranchreporting
      if (this.currentUserRole === 'Corporate') {
        this.mapApeSummaryData(responseData.data.responsedata.corporateapedata[0], responseData.data.responsedata.projectconfiguration);
        this.__formatInceptedApeByBranchData(responseData.data.responsedata.branchdata, responseData.data.responsedata.affinitybranch);
      }
      else if (this.currentUserRole === 'BDM') {
        this.mapApeSummaryData(responseData.data.responsedata.bdmapedata[0], responseData.data.responsedata.projectconfiguration);
        this.__formatInceptedApeByBranchData(responseData.data.responsedata.bdmbranchreporting, responseData.data.responsedata.affinitybranch);
      }
      else if (['Manager', 'Director'].includes(this.currentUserRole)) {
        this.__formatInceptedApeByAdvisorData(responseData.data.responsedata.apedata);
        this.mapApeSummaryData(responseData.data.responsedata.apesummary[0], responseData.data.responsedata.projectconfiguration);
      }
      else {
        this.mapApeSummaryData(responseData.data.responsedata.apesummary[0], responseData.data.responsedata.projectconfiguration);
      }
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("Something went wrong!!!");
      }
      if(responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  async getDashboardDirectorwiseManagers() {
    const responseData = await this.dashboardManagerTeamService
      .getDashboardInceptedApeDirectorwiseManager()
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        console.error(error);
        return error;
      });
    if (responseData.status === HttpStatusCode.Ok) {
      let managerTableData: any[] = responseData.data.responsedata;
      managerTableData.forEach((manager) => {
        this.inceptedApeByManagerData.push({
          repCode: manager.piasRepCode.toString(),
          personName: manager.agentRealName.toString(),
          branch: manager.branch.toString(),
          monthSinglife: Number.parseInt(manager.mtdSinglife.toString()),
          monthSinglifeCase: Number.parseInt(manager.mtdSinglifeCase.toString()),
          monthNonsinglife: Number.parseInt(manager.mtdNonSinglife.toString()),
          monthNonsinglifeCase: Number.parseInt(manager.mtdNonSinglifeCase.toString()),
          yearSinglife: Number.parseInt(manager.ytdSinglife.toString()),
          yearSinglifeCase: Number.parseInt(manager.ytdSinglifeCase.toString()),
          yearNonsinglife: Number.parseInt(manager.ytdNonSinglife.toString()),
          yearNonsinglifeCase: Number.parseInt(manager.ytdNonSinglifeCase.toString()),
          yearTarget: 0,
          yearTotal: Number.parseInt(manager.ytdSinglife.toString()) + Number.parseInt(manager.ytdNonSinglife.toString()),
          userGroup: manager.userGroup.toString()
        });
      });

      // this.inceptedApeByManagerData = this.inceptedApeByManagerData.filter(item => item.userGroup !== 'Affinity');
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("Something went wrong!!!");
      }
      if(responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  clearSearch() {
    this.inceptedApeByAdvisorTableFilterFc.setValue('');
    this.__applyInceptedApeByAdvisorDataFilter();
  }

  clearBranchSearch() {
    this.inceptedApeByBranchTableFilterFc.setValue('');
    this.__applyInceptedApeByBranchDataFilter();
  }
  clearManagerSearch() {
    this.inceptedApeByManagerTableFilterFc.setValue('');
    this.__applyInceptedApeByManagerDataFilter();
  }


  private mapApeSummaryData(apeData: any, projConfig: any[]) {
    this.inceptedApeSummary = {
      monthSinglife: apeData.mtdSinglife,
      monthNonsinglife: apeData.mtdNonSinglife,
      monthSinglifeCase: apeData.mtdSinglifeCase,
      monthNonsinglifeCase: apeData.mtdNonSinglifeCase,
      yearSinglife: apeData.ytdSinglife,
      yearNonsinglife: apeData.ytdNonSinglife,
      yearSinglifeCase: apeData.ytdNonSinglifeCase,
      yearNonsinglifeCase: apeData.ytdSinglifeCase,
      yearTarget: projConfig.filter(pcItem => pcItem.pjConfName === "Incepted_APE_Year_Target")[0].pjConfValue
    };
  }

  private __formatInceptedApeByAdvisorData(inceptedApeByAdvisorDataList: any[]) {
    inceptedApeByAdvisorDataList.forEach((inceptedApeByAdvisorDataItem: any) => {
      this.inceptedApeByAdvisorData.push({
        repCode: inceptedApeByAdvisorDataItem.piasRepCode,
        personName: inceptedApeByAdvisorDataItem.agentRealName.toString().trim(),
        branch: inceptedApeByAdvisorDataItem.branch.toString().trim(),
        monthSinglife: inceptedApeByAdvisorDataItem.mtdSinglife,
        monthSinglifeCase: inceptedApeByAdvisorDataItem.mtdSinglifeCase,
        monthNonsinglife: inceptedApeByAdvisorDataItem.mtdNonSinglife,
        monthNonsinglifeCase: inceptedApeByAdvisorDataItem.mtdNonSinglifeCase,
        yearSinglife: inceptedApeByAdvisorDataItem.ytdSinglife,
        yearSinglifeCase: inceptedApeByAdvisorDataItem.ytdSinglifeCase,
        yearNonsinglife: inceptedApeByAdvisorDataItem.ytdNonSinglife,
        yearNonsinglifeCase: inceptedApeByAdvisorDataItem.ytdNonSinglifeCase,
        yearTarget: inceptedApeByAdvisorDataItem.yealyTarget,
        yearTotal: (inceptedApeByAdvisorDataItem.ytdSinglife + inceptedApeByAdvisorDataItem.ytdNonSinglife),
        userGroup: inceptedApeByAdvisorDataItem.userGroup.toString()
      });
    });

    // this.inceptedApeByAdvisorData = this.inceptedApeByAdvisorData.filter(item => item.userGroup !== 'Affinity');
  }

  private __formatInceptedApeByBranchData(inceptedApeByBranchDataList: any[], affinitybranch: any[]) {
    inceptedApeByBranchDataList.forEach((inceptedApeByBranchDataItem: any) => {
      this.inceptedApeByBranchData.push({
        branchName: inceptedApeByBranchDataItem.branch,
        monthSinglife: inceptedApeByBranchDataItem.mtdSinglife,
        monthSinglifeCase: inceptedApeByBranchDataItem.mtdSinglifeCase,
        monthNonsinglife: inceptedApeByBranchDataItem.mtdNonSinglife,
        monthNonsinglifeCase: inceptedApeByBranchDataItem.mtdNonSinglifeCase,
        yearSinglife: inceptedApeByBranchDataItem.ytdSinglife,
        yearSinglifeCase: inceptedApeByBranchDataItem.ytdSinglifeCase,
        yearNonsinglife: inceptedApeByBranchDataItem.ytdNonSinglife,
        yearNonsinglifeCase: inceptedApeByBranchDataItem.ytdNonSinglifeCase,
        yearTarget: inceptedApeByBranchDataItem.yealyTarget,
        yearTotal: (inceptedApeByBranchDataItem.ytdSinglife + inceptedApeByBranchDataItem.ytdNonSinglife)
      });
    });

    // this.inceptedApeByBranchData = this.inceptedApeByBranchData.filter(branch => !affinitybranch.find(item => item.branchName === branch.branchName));
  }

  protected __applyInceptedApeByAdvisorDataFilter() {
    let filterValue: string = this.inceptedApeByAdvisorTableFilterFc.value?.toString() || '';

    let tempInceptedApeByAdvisorTableData: InceptedApeByAdvisors[] = [];

    if (filterValue) {
      tempInceptedApeByAdvisorTableData = this.inceptedApeByAdvisorData.filter(apeData =>
        apeData.repCode.toString().includes(filterValue)
        || apeData.personName.toLowerCase().includes(filterValue.toLowerCase()
        ));
    } else {
      tempInceptedApeByAdvisorTableData = this.inceptedApeByAdvisorData;
    }

    this.inceptedApeByAdvisorTableDataSource.data = tempInceptedApeByAdvisorTableData;
  }

  protected __applyInceptedApeByBranchDataFilter() {
    let filterValue: string = this.inceptedApeByBranchTableFilterFc.value?.toString() || '';

    let tempInceptedApeByBranchTableData: InceptedApeByBranches[] = [];

    if (filterValue) {
      tempInceptedApeByBranchTableData = this.inceptedApeByBranchData.filter(apeData =>
        apeData.branchName.toLowerCase().includes(filterValue.toLowerCase()
        ));
    } else {
      tempInceptedApeByBranchTableData = this.inceptedApeByBranchData;
    }

    this.inceptedApeByBranchTableDataSource.data = tempInceptedApeByBranchTableData;
  }

  protected __applyInceptedApeByManagerDataFilter() {
    let filterValue: string = this.inceptedApeByManagerTableFilterFc.value?.toString() || '';

    let tempInceptedApeByManagerTableData: InceptedApeByAdvisors[] = [];

    if (filterValue) {
      tempInceptedApeByManagerTableData = this.inceptedApeByManagerData.filter(apeData =>
        apeData.repCode.toString().includes(filterValue)
        || apeData.personName.toLowerCase().includes(filterValue.toLowerCase()
        ));
    } else {
      tempInceptedApeByManagerTableData = this.inceptedApeByManagerData;
    }

    this.inceptedApeByManagerTableDataSource.data = tempInceptedApeByManagerTableData;
  }

  protected __displayBranchWiseAdvisors(brancName: string) {
    const viewBranchAdvisorsDialogRef = this.matDialog.open(ViewInceptedApeBranchAdvisorsDialog, {
      data: {
        branchName: brancName
      },
      width: "calc(100vw - 30px)",
      maxWidth: "calc(100vw - 30px)",
      height: "calc(100vh - 75px)",
      panelClass: 'branch-popup-dialog',
      maxHeight: "calc(100vh - 75px)",
      position: {
        bottom: "20px"
      }
    });
  }

  protected __displayManagerWiseAdvisors(managerRepCode: string, managerName: string) {
    const viewManagerAdvisorsDialogRef = this.matDialog.open(ViewInceptedApeManagerAdvisorsDialog, {
      data: {
        managerRepCode: managerRepCode,
        managerName: managerName
      },
      width: "calc(100vw - 30px)",
      maxWidth: "calc(100vw - 30px)",
      height: "calc(100vh - 75px)",
      panelClass: 'branch-popup-dialog',
      maxHeight: "calc(100vh - 75px)",
      position: {
        bottom: "20px"
      }
    });
  }
}
